module.exports = __webpack_public_path__ + "img/highlights.51f45d2c.png";